import { render, staticRenderFns } from "./afterScanDetailsNew.vue?vue&type=template&id=80fea4be&scoped=true&"
import script from "./afterScanDetailsNew.vue?vue&type=script&lang=js&"
export * from "./afterScanDetailsNew.vue?vue&type=script&lang=js&"
import style0 from "./afterScanDetailsNew.vue?vue&type=style&index=0&id=80fea4be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fea4be",
  null
  
)

export default component.exports